export default function Loading() {
  return <h6 className="text-center text-lg font-normal">Loading...</h6>;
}
